import ShowElements from "@/components/drawer/ShowElements";
import { TypeDefaultImage } from "@/lib/image";
import { Attachment } from "@/lib/types";
import { ACTION_VIEW_ICON } from "@/components/table/action-icons";
import { Pencil, Trash2 } from "lucide-react";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { ACTION_I18N_KEYS } from "./action-i18n-keys";
import { TableRowActionsMenu } from "./TableRowActionsMenu";

type PreviewElement = {
  label: string;
  value: string | Attachment[];
  type: "text" | "richtext" | "image";
};

type LinkDrawerRowActionsProps = {
  previewType: TypeDefaultImage;
  previewId: string;
  previewElements: PreviewElement[];
  onDelete?: () => void;
  editLabel?: string;
  editDrawer?: (props: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }) => ReactNode;
  showPreview?: boolean;
};

export function LinkDrawerRowActions({
  previewType,
  previewId,
  previewElements,
  onDelete,
  editLabel,
  editDrawer,
  showPreview = true,
}: LinkDrawerRowActionsProps) {
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);

  const actions = [
    ...(editDrawer
      ? [
          {
            id: "edit",
            label: editLabel ?? t(ACTION_I18N_KEYS.edit),
            icon: Pencil,
            onSelect: () => setEditOpen(true),
          },
        ]
      : []),
    ...(showPreview
      ? [
          {
            id: "preview",
            label: t(ACTION_I18N_KEYS.view),
            icon: ACTION_VIEW_ICON,
            onSelect: () => setPreviewOpen(true),
          },
        ]
      : []),
    {
      id: "delete",
      label: t(ACTION_I18N_KEYS.delete),
      icon: Trash2,
      destructive: true,
      hidden: !onDelete,
      onSelect: onDelete,
    },
  ];

  return (
    <div className="flex justify-end" onClick={(event) => event.stopPropagation()}>
      {showPreview && (
        <ShowElements
          type={previewType}
          id={previewId}
          elements={previewElements}
          open={previewOpen}
          onOpenChange={setPreviewOpen}
        />
      )}
      {editDrawer?.({ open: editOpen, onOpenChange: setEditOpen })}
      <TableRowActionsMenu actions={actions} />
    </div>
  );
}
